import * as React from "react";
import { IndicatorHybrid } from "./IndicatorHybrid";
import type { TypeIndicatorProps } from "./IndicatorTypes";

/**
 * Indicator component. Automatically routes between the Tailwind
 * implementation (preferred) and the styled-components implementation (for
 * consumers using system props or styled() extension).
 */
export const Indicator = (props: TypeIndicatorProps) => (
  <IndicatorHybrid {...props} />
);
